export default __webpack_public_path__ + "static/media/Broadform-homeowners-KID-2025.02a4001e.pdf";